import { useState } from 'react';

import { TAttachmentOnClient } from '@entities/attachment/model/types';
import { generateMeasurement } from '@features/GenerateMeasurement/api/generateMeasurement';
import { useDialog } from '@shared/hooks';

import { useAppDispatch } from '../../../../store';
import { measurementsActions } from '../../../../store/slices/measurementsSlice/measurementsSlice';
import { formatAndConvertToNumber } from '../../../../TemporaryConmonents/Measurements/helpers/formatAndConvertToNumber';

export const useGenerateMeasurement = () => {
    const dispatch = useAppDispatch();

    const { isOpen, open, close } = useDialog();
    const [isGenerate, setIsGenerate] = useState(false);

    const [popupData, setPopupData] = useState<null | string>(null);
    const onGenerateMeasurement = async (attachment: TAttachmentOnClient, height: string) => {
        setIsGenerate(true);
        const formData = new FormData();
        formData.append('image', attachment.file);
        formData.append('height', height === '' ? '' : `${formatAndConvertToNumber(height)}`);
        close();
        const generatedMeasurement = await generateMeasurement(formData);
        setIsGenerate(false);
        if (generatedMeasurement.status === 'success') {
            setPopupData(generatedMeasurement.message);
            dispatch(measurementsActions.addGeneratedMeasurements(generatedMeasurement.data));
        }
    };

    const onHidePopup = () => {
        setPopupData(null);
    };
    return {
        open,
        isOpen,
        onGenerateMeasurement,
        close,
        isGenerate,
        popupData,
        onHidePopup,
    };
};
